import React from "react";

/**
 * Footer key for the phone layouts of the dashboard reports. A phone has no
 * width for a line column beside the names, so it drops that column and names
 * the family lines down here once instead of on every row. The wide layouts do
 * the opposite: the head of line is printed on the row and no key is rendered.
 *
 * Renders: | Family Lines: Mary M | Roger, Sr.  — each head's name printed in
 * their own line colour, which is what ties them to the coloured line names in
 * the rows above. Entries are separated by a light grey rule. The colour name
 * itself stays as the entry's tooltip for anyone who needs it spelled out.
 *
 * The leading separator is hidden by CSS when the legend is the first thing in the
 * footer (pages whose lists carry no in-law / deceased / multiple-birth markers,
 * so DashboardMarkerLegend renders nothing before it).
 *
 * @param {Array<{headName?: string, colorName: string, hexCode: string}>} lines
 */
export default function DashboardColorLegend({
  lines,
  label = "Family Lines:",
  suffix = " Ln",
}) {
  if (!lines?.length) return null;

  return (
    <div className="heads-of-line-color-legend">
      <span className="heads-of-line-color-legend-title">
        <span className="heads-of-line-color-legend-separator" aria-hidden="true">
          |
        </span>
        {label}
      </span>
      {lines.map(({ headName, colorName, hexCode }, index) => (
        <React.Fragment key={`${headName || ""}-${colorName}-${hexCode}`}>
          {index > 0 && (
            <span
              className="heads-of-line-color-legend-divider"
              aria-hidden="true"
            />
          )}
          <span
            className="heads-of-line-color-legend-item"
            title={`${colorName}${suffix}`}
          >
            {headName ? (
              <span
                className="heads-of-line-color-legend-head"
                style={{ color: hexCode }}
              >
                {headName}
              </span>
            ) : (
              <span
                className="heads-of-line-color-legend-label"
                style={{ color: hexCode }}
              >
                {colorName}
                {suffix}
              </span>
            )}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}
